import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Typography, makeStyles } from '@material-ui/core';
import { getColumnWidth, getAlignItem } from '../../../../constants/gridTable';

const useStyles = makeStyles(({ spacing }) => ({
  root: {
    display: 'grid',
    boxSizing: 'border-box',
  },
  headerCell: {
    boxSizing: 'border-box',
    cursor: 'default',
    padding: spacing(0, 2, 4.5, 0),
    textAlign: 'left',
    lineHeight: '24px',
    userSelect: 'none',
  },
}));

const Header = ({ className = undefined, columns }) => {
  const classes = useStyles();

  return (
    <div
      className={classNames(classes.root, 'grid-table-header', className)}
      style={getColumnWidth(columns)}
    >
      {columns.map(header => (
        <Typography
          key={`header_cell_${header.id}`}
          component="div"
          variant="subtitle1"
          className={classNames(
            classes.headerCell,
            'header-cell',
            header.headerCellClass
          )}
          style={getAlignItem(header)}
        >
          {header.title || ''}
        </Typography>
      ))}
    </div>
  );
};

Header.propTypes = {
  className: PropTypes.string,
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default Header;
